import axios from "axios";

const BASE_URL = import.meta.env.VITE_API_BASE_URL;
const USER_PLAN_COUNT_UPDATED_EVENT = 'user-plan-count-updated'

export const emitUserPlanCountUpdated = (payload) => {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(
    new CustomEvent(USER_PLAN_COUNT_UPDATED_EVENT, {
      detail: payload,
    })
  )
}

export const postUserPlanCount = async (body) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem("token"));

  const config = {
    headers: {
      Authorization: "Bearer " + STORAGE_TOKEN,
    },
    withCredentials: true,
  };

  return await axios
    .post(`${BASE_URL}user-plan-counts`, body, config)
    .then((response) => {
      emitUserPlanCountUpdated(response.data)
      return {
        data: response.data,
        responseStatus: response.status,
      };
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear();
        window.location.reload();
      }
      console.log("error postProduct", error.response.data);
      return error;
    });
};

export const postUserPlanCount2 = async (body) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem("token"));

  const config = {
    headers: {
      Authorization: "Bearer " + STORAGE_TOKEN,
    },
    withCredentials: true,
  };

  return await axios
    .post(`${BASE_URL}user-plan-counts`, body, config)
    .then((response) => {
      emitUserPlanCountUpdated(response.data)
      return {
        data: response.data,
        responseStatus: response.status,
      };
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear();
        window.location.reload();
      }
      console.log("error postUserPlanCount", error.response.data);
      return error;
    });
};

export const getUserPlanCountByUser = async () => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem("token"));

  const config = {
    headers: {
      Authorization: "Bearer " + STORAGE_TOKEN,
    },
    withCredentials: true,
  };

  return await axios
    .get(`${BASE_URL}user-plan-counts-by-user`, config)
    .then((response) => {
      return {
        data: response.data,
        responseStatus: response.status,
      };
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear();
        window.location.reload();
      }
      console.log("error getUserPlanCountByUser", error.response.data);
      return error;
    });
};

export const putUserPlanCount = async (id, body) => {
  const STORAGE_TOKEN = JSON.parse(window.localStorage.getItem("token"));

  const config = {
    headers: {
      Authorization: "Bearer " + STORAGE_TOKEN,
    },
    withCredentials: true,
  };

  return await axios
    .put(`${BASE_URL}user-plan-counts/${id}`, body, config)
    .then((response) => {
      emitUserPlanCountUpdated(response.data)
      return {
        data: response.data,
        responseStatus: response.status,
      };
    })
    .catch(function (error) {
      if (error.response.status === 401) {
        window.localStorage.clear();
        window.location.reload();
      }
      console.log("error putUserPlanCount", error.response.data);
      return error;
    });
};
